import React, { Component } from 'react';
import ImportUser from '../../UserManagement/components/ImportUser';
import { PriorDataImport } from './PriorDataImport';
import { Button, Container, Dropdown, Form, Spinner, Tab, Table, Tabs } from "react-bootstrap";
import { CommonService } from "../../../Common/Services/CommonService";
import { RoleSubPermissionSetting, IPageSubPermissionRole } from "../../../Common/Services/RoleSubPermissionSetting";
import { resolve, reject } from "q";
import "./ImplementationImport.scss";
class ImplementationImport extends Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            BlobbaseUrl: "",
            isPriorPermission: false,
            isImportPermission: false,
        }
    }

    componentDidMount(): void {
        let storage = JSON.parse(localStorage.getItem("storage")!);
        let tenantID = storage === null ? 0 : storage.tenantID;
        if (tenantID === 230) {
            this.GetChildPermission();
        }
    }

    GetChildPermission = () => {
        let requestObject:any = {} ;
        requestObject.PermissionName = "Implementation Import";        
        RoleSubPermissionSetting.GetChildPermission(requestObject)
            .then(async (result: any | null) => {
                if (result != null && result.length > 0) {
                    this.setState({
                        isImportPermission: result.some((o) => o.permissionName.toLowerCase() === "import users"),
                        isPriorPermission: result.some((o) => o.permissionName.toLowerCase() === "prior data import"),
                    }, () => {
                        if (!this.state.isImportPermission && this.state.isPriorPermission) {
                            this.setState({ key: "PriorDataImport" })
                        } else {
                            this.setState({ key: "importuser" })
                        }
                        if (this.state.isImportPermission || this.state.isPriorPermission) {
                            this.getBlobbaseUrl();
                        } else {
                            window.location.href = "/unauthorize-access";
                        }
                    });
                } else{
                    window.location.href = "/unauthorize-access";
                }
                resolve();
            })
            .catch((err: any) => {
                reject();
            });
    };


    handleTabSelect = (eventKey: any) => {
        this.setState({ key: eventKey });
    }

    getBlobbaseUrl = () => {
        let keyName = "BlobbaseUrl";
        let BlobbaseUrl = "";
        CommonService.GetInnflowConfigKeyValue(keyName)
            .then(async (result: any | null) => {
                console.log(result);
                if (result !== null) {
                    BlobbaseUrl = result;
                    this.setState({ BlobbaseUrl: BlobbaseUrl });
                }
            });
    }

    downloadTemplateImport = () => {
        let BlobbaseUrl = this.state.BlobbaseUrl;
        const filename = "ImportUser.xlsx"
        const link = document.createElement("a")
        //link.href="https://innflowfilestoretest.blob.core.windows.net/innflowtemplate/ImportUser.xlsx"
        link.href = BlobbaseUrl + "innflowtemplate/ImportUser.xlsx"
        link.download = filename
        link.click()
    }

    downloadTemplatePrior = () => {
        let BlobbaseUrl = this.state.BlobbaseUrl;
        //'https://innflowfilestoretest.blob.core.windows.net/innflowtemplate/PriorDataImport.xlsx'
        fetch(BlobbaseUrl + 'innflowtemplate/PriorDataImport.xlsx', {
            method: 'GET', headers: { 'Content-Type': 'application/vnd.ms-excel' }
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `PriorDataImport.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    }

    render() {
        let { key, isImportPermission, isPriorPermission } = this.state;
        let isImportTab = key === "importuser";
        return (
            <Container fluid className="body-sec">
                {(isImportPermission || isPriorPermission) && (
                    <div className="ImplementationImport">
                        <div className={`page-heading d-flex`}>
                            <div className="mr-auto">Implementation Import</div>
                            {isImportTab ? (
                                <Button onClick={this.downloadTemplateImport} title="Import Users Template" className="btn btn-primary">Download Template</Button>
                            ) : (
                                <Button onClick={this.downloadTemplatePrior} title="Prior Data Import Template" className="btn btn-primary">Download Template</Button>
                            )}
                        </div>
                        <Tabs defaultActiveKey={key} id="ImplementationImport" onSelect={this.handleTabSelect}>
                            {isImportPermission && (
                                <Tab key="importuser" eventKey="importuser" title="Import Users">
                                    <ImportUser />
                                </Tab>
                            )}
                            {isPriorPermission && (
                                <Tab key="PriorDataImport" eventKey="PriorDataImport" title="Prior Data Import">
                                    <PriorDataImport
                                        downloadTemplate={this.downloadTemplatePrior}
                                    />
                                </Tab>
                            )}
                        </Tabs>
                    </div>
                )}
            </Container>
        );
    }
}

export default ImplementationImport;